import "core-js/modules/es.object.assign.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["innerHTML"];
import { ref, onBeforeMount, onUnmounted, watch } from "vue";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import { ArrowIcon } from "@vueEntry/SvgIcons/ArrowIcon";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'BaseDropDown',
  props: {
    id: {
      default: ""
    },
    dropdownClasses: {
      default: ""
    },
    containerDropdownClasses: {
      default: ""
    },
    iconName: {
      default: ""
    },
    iconClasses: {
      default: ""
    },
    btnClasses: {
      default: ""
    },
    withArrowIcon: {
      type: Boolean,
      default: false
    },
    btnLabel: {
      default: ""
    },
    labelClasses: {
      default: ""
    },
    direction: {
      default: "down"
    },
    arrowWidth: {
      default: 12
    },
    isAbsolute: {
      type: Boolean,
      default: true
    },
    openDropdown: {
      type: Boolean,
      default: false
    },
    closeWhenClickedOutside: {
      type: Boolean,
      default: true
    },
    dropdownElement: {
      default: "div"
    },
    keepState: {
      default: ""
    }
  },
  emits: ["click", "update:dropdownState"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emits = __emit;
    var open = ref(false);
    watch(() => props.openDropdown, cur => {
      open.value = cur;
    }, {
      immediate: true
    });
    watch(open, cur => {
      emits("update:dropdownState", cur);
    });
    var closeDropdown = () => {
      open.value = false;
    };
    var toggleHandle = () => {
      if (props.keepState === "closed" && !open.value || props.keepState === "opened" && open.value) return;
      open.value = !open.value;
    };
    onBeforeMount(() => {
      if (props.closeWhenClickedOutside) document.body.addEventListener("click", closeDropdown);
    });
    onUnmounted(() => {
      if (props.closeWhenClickedOutside) document.body.removeEventListener("click", closeDropdown);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["tw-relative tw-block", _ctx.$attrs['class']]),
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => {
          emits('click');
          toggleHandle();
        }, ["stop"]))
      }, [_renderSlot(_ctx.$slots, "btn_slot", {
        toggleDropdown: toggleHandle,
        isOpen: open.value
      }, () => [_createVNode(BaseButton, {
        id: _ctx.id,
        type: "button",
        "data-cy": _ctx.$attrs['data-cy'],
        class: _normalizeClass(['tw-w-full tw-truncate !tw-flex tw-items-center', _ctx.btnClasses]),
        "aria-expanded": open.value,
        "btn-class": "tw-btn-single-selection",
        "icon-class": _ctx.iconClasses,
        "icon-name": _ctx.iconName
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          class: _normalizeClass(["tw-mr-5px", _ctx.labelClasses]),
          innerHTML: _ctx.btnLabel
        }, null, 10 /* CLASS, PROPS */, _hoisted_1), _ctx.withArrowIcon ? (_openBlock(), _createBlock(_unref(ArrowIcon), {
          key: 0,
          class: _normalizeClass(["tw-transition-transform motion-reduce:tw-transition-none tw-shrink-0", open.value && 'tw-rotate-180']),
          width: _ctx.arrowWidth,
          height: _ctx.arrowWidth,
          "stroke-color": _ctx.$attrs['arrow-stroke-color']
        }, null, 8 /* PROPS */, ["class", "width", "height", "stroke-color"])) : _createCommentVNode("v-if", true)]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["id", "data-cy", "class", "aria-expanded", "icon-class", "icon-name"])]), (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dropdownElement), {
        id: 'dropdown_' + _ctx.id,
        ref: "dropdown",
        "data-cy": "".concat(_ctx.$attrs['data-cy'], "_dropdown"),
        class: _normalizeClass(["tw-bg-white tw-opacity-100 tw-min-w-[90px] tw-max-h-[220px] tw-w-full tw-flex-col tw-border tw-border-solid tw-border-w-lavender tw-no-scrollbar tw-overflow-y-auto tw-shadow", [_ctx.dropdownClasses, open.value ? 'tw-flex' : 'tw-hidden', {
          'tw-bottom-[55px] tw-rounded-xs': _ctx.direction === 'up'
        }, {
          'tw-rounded-b tw-border-t-0': _ctx.direction === 'down'
        }, {
          'tw-absolute': _ctx.isAbsolute
        }]]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {
          isOpen: open.value
        }, () => [_createCommentVNode(" Some content goes in here")])]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["id", "data-cy", "class"]))], 2 /* CLASS */);
    };
  }
}));